var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDashboard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.63278 2.83471L2.88278 2.83924C2.4003 2.83983 2.00829 3.23279 2.00887 3.71527L2.01159 5.96527C2.01218 6.44785 2.40513 6.83986 2.88762 6.83927L6.63762 6.83474C7.12019 6.83415 7.5122 6.44119 7.51162 5.95862L7.5089 3.70862C7.50831 3.22613 7.11536 2.83412 6.63278 2.83471ZM6.63883 7.83467L2.88883 7.83921C2.40634 7.83979 2.01433 8.23275 2.01492 8.71533L2.02127 13.9653C2.02185 14.4478 2.41481 14.8398 2.89729 14.8392L6.64729 14.8347C7.12987 14.8341 7.52188 14.4412 7.5213 13.9587L7.51495 8.70868C7.51436 8.2261 7.1214 7.83409 6.63883 7.83467ZM13.1425 10.8268L9.39251 10.8313C8.90994 10.8319 8.51793 11.2249 8.51851 11.7075L8.52123 13.9575C8.52182 14.4399 8.91477 14.832 9.39735 14.8314L13.1473 14.8268C13.6298 14.8263 14.0218 14.4333 14.0213 13.9508L14.0185 11.7008C14.018 11.2182 13.625 10.8262 13.1425 10.8268ZM13.1328 2.82685L9.38284 2.83138C8.90026 2.83197 8.50825 3.22492 8.50883 3.70741L8.51518 8.9574C8.51577 9.43998 8.90873 9.83199 9.39131 9.83141L13.1413 9.82687C13.6238 9.82629 14.0158 9.43333 14.0152 8.95075L14.0089 3.70076C14.0083 3.21827 13.6153 2.82626 13.1328 2.82685Z",
    fill: "#86878A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashboard);
export default __webpack_public_path__ + "static/media/Dashboard.c8a80a69e3c1e73c7e43c3660bb5d0c0.svg";
export { ForwardRef as ReactComponent };